// Define UI Constants
// The Joi library imported in bcm-datastructures throws "TextEncoder" errors
// By importing this encoder/decoder where the joi module is implicitely loaded
// This fixes the error. Pray that it remains fixed
import 'fastestsmallesttextencoderdecoder';

import { UI } from '@bcm/constants';

export const ALERT_TYPES = {
	confirm: 'confirm',
	reconnect: 'reconnect',
	confirmCancel: 'confirmCancel',
	confirmResetPassword: 'confirmResetPassword',
	delete: 'delete',
};

export const MODAL_TYPES = {
	view: 'view',
	edit: 'edit',
	create: 'create',
	overlay: 'overlay',
};

export const FORM_TYPES = {
	input: 'input',
	text: 'text',
	date: 'date',
	selector: 'selector',
	multiSelector: 'multiSelector',
	switch: 'switch',
	header: 'header',
	code: 'code',
	phoneNumber: 'phoneNumber',
	consent: 'consent',
	radio: 'radio',
	richText: 'richText',
};

export const TOAST_TYPES = {
	success: 'success',
	error: 'error',
	info: 'info',
};

export const REVIEW_TYPES = {
	text: 'text',
	bodySites: 'bodySites',
};

export const USER_CIRCLE_TYPES = {
	messages: 'messages',
	annotations: 'annotations',
	userCard: 'userCard',
};

export const TEXT_ANNOTATION_TYPES = {
	condition: 'condition',
	bodySite: 'bodySite',
	image: 'image',
};

export const ICON_SIZE = {
	xxxl: 90,
	xxl: 80,
	xl: 72,
	lg: 40,
	md: 36,
	sm: 32,
	xs: 22,
	xxs: 18,
	xxxs: 14,
};

export const INPUT_LENGTH = {
	MIN_PASSWORD: 8,
	MAX_PASSWORD: 100,
	MAX_USERNAME: 100,
	MAX_INPUT: 50000,
	MAX_CHANNEL_NAME: 100,
	MAX_PERSON_NAME: 100,
	MAX_TEAM_NAME: 100,
	MAX_ORG_NAME: 100,
	MAX_ORG_DETAIL: 100,
	MAX_PAGE_NAME: 100,
};

export const VERIFICATION_CODE_LENGTH = 6;

export const ERROR_TYPES = {
	required: 'required',
	min: 'min',
	max: 'max',
	minLength: 'minLength',
	maxLength: 'maxLength',
	pattern: 'pattern',
	custom: 'custom',
};

export const QUERY_TYPES = {
	search: 'search',
	radio: 'radio',
	checkbox: 'checkbox',
};

export const USER_SEARCH = {
	firstName: {
		label: 'First Name',
		key: 'firstName',
	},
	lastName: {
		label: 'Last Name',
		key: 'lastName',
	},
};

export const BODY_SITE_COMPOSITE_TYPES = {
	analysis: 'analysis',
	images: 'images',
};

export const TEXT_EDITOR_TOOLBAR_TYPE = {
	full: 'full',
	half: 'half',
};

export const MESSAGE_STATES = {
	sending: 'sending',
	sent: 'sent',
	failed: 'failed',
};

// Import and rename UI constants from bcm-constants
export const ADDRESS_TYPES = UI.ADDRESS_TYPES;
export const APPOINTMENT_RESPONSES = UI.APPOINTMENT_RESPONSES;
export const CHANNEL_TYPES = UI.CHANNEL_TYPES;
export const CONTACT_POINT_SYSTEM = UI.CONTACT_POINT_SYSTEM;
export const CONTACT_POINT_USE = UI.CONTACT_POINT_USE;
export const GENDERS = UI.GENDERS;
export const MESSAGE_TYPES = UI.MESSAGE_TYPES;
export const NAME_USE = UI.NAME_USE;
export const PLATFORM_TYPES = UI.PLATFORM_TYPES;
export const PRIMARY_ROLES = UI.PRIMARY_ROLES;
export const QUALIFICATIONS = UI.QUALIFICATIONS;
export const REASON_REFERENCES = UI.REASON_REFERENCES;
export const SEXES = UI.SEXES;
export const STATES = UI.STATES;
export const TAG_OWNER_TYPES = UI.TAG_OWNER_TYPES;
export const TAG_TYPES = UI.TAG_TYPES;
export const UNITS = UI.UNITS;
export const USER_TYPES = UI.USER_TYPES;
export const WORKSPACE_TYPES = UI.WORKSPACE_TYPES;
export const NOTIFICATION_TYPES = UI.NOTIFICATION_TYPES;
export const LIBRARY_TYPES = UI.LIBRARY_TYPES;
export const PAGE_TYPES = UI.PAGE_TYPES;
export const ORG_CONFIGS = UI.ORG_CONFIGS;
export const CONFERENCE_ROOM_TYPES = UI.CONFERENCE_ROOM_TYPES;
export const CONFERENCE_ROOM_MESSAGE_TYPES = UI.CONFERENCE_ROOM_MESSAGE_TYPES;
export const DUPLEX_SERVICES = UI.DUPLEX_SERVICES;
export const AGE_CATEGORIES = UI.AGE_CATEGORIES;
